import { required, email } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';

export const form = () => cloneDeep({
  firstName: {
    label: 'First name',
    type: 'text',
    value: '',
  },
  lastName: {
    label: 'Last name',
    type: 'text',
    value: '',
  },
  email: {
    label: 'Email',
    type: 'email',
    value: '',
  },
  active: {
    label: 'Active',
    type: 'checkbox',
    value: 0,
  },
  teams: {
    label: 'Teams',
    type: 'multiselect',
    labelBy: 'team',
    trackBy: 'team',
    value: null,
    options: [],
    multiple: true,
  },
});

export const validators = {
  firstName: {
    required,
  },
  lastName: {
    required,
  },
  email: {
    required,
    email,
  },
  active: {},
};
